<template lang="pug">
v-container(fluid='')
        v-card
          v-card-title.d-flex.justify-space-between
            span Gesti&oacute;n de Documentos
            v-btn(color='primary', @click='openDialog()')
              v-icon(left='') mdi-plus
              |  Nuevo Documento
          v-card-text
            v-data-table(:headers='headers', :items='documents', :loading='loading', :search='search')
              template(v-slot:top='')
                v-text-field.mx-4(v-model='search', label='Buscar documento', prepend-inner-icon='mdi-magnify', clearable='')
              template(v-slot:item.type='{ item }')
                  v-chip(small='') {{ getDocumentType(item.type) }}
              template(v-slot:item.date='{ item }')
                    | {{ formatDate(item.date) }}
              template(v-slot:item.total='{ item }')
                      | ${{ item.total }}
              template(v-slot:item.actions='{ item }')
                        v-btn.mr-2(icon='', small='', @click='openDialog(item)')
                          v-icon mdi-pencil
                        v-btn(icon='', small='', @click='viewDocument(item)')
                          v-icon mdi-eye
        // Document Form Dialog
        v-dialog(v-model='dialog', max-width='800')
          v-card
            v-card-title
              | {{ editedItem._id ? &apos;Editar&apos; : &apos;Nuevo&apos; }} Documento
            v-card-text
              v-form(ref='form', v-model='valid')
                v-row
                  v-col(cols='12', sm='6')
                    v-select(v-model='editedItem.type', :items='documentTypes', label='Tipo de Documento', required='', :rules="[v => !!v || 'El tipo es requerido']")
                  v-col(cols='12', sm='6')
                    v-menu(ref='dateMenu', v-model='dateMenu', :close-on-content-click='false', transition='scale-transition', offset-y='', min-width='auto')
                      template(v-slot:activator='{ on, attrs }')
                        v-text-field(v-model='editedItem.date', label='Fecha', readonly='', v-bind='attrs', v-on='on', required='', :rules="[v => !!v || 'La fecha es requerida']")
                      v-date-picker(v-model='editedItem.date', @input='dateMenu = false')
                  v-col(cols='12', sm='6')
                    v-text-field(v-model='editedItem.number', label='Número', required='', :rules="[v => !!v || 'El número es requerido']")
                  v-col(cols='12', sm='6')
                    v-select(v-model='editedItem.supplier', :items='suppliers', item-text='businessName', item-value='_id', label='Proveedor', required='', :rules="[v => !!v || 'El proveedor es requerido']")
                  // Items Table
                  v-col(cols='12')
                    v-simple-table
                      template(v-slot:default='')
                        thead
                          tr
                            th Art&iacute;culo
                            th Unidad de medida
                            th Cantidad
                            th Precio Unit.
                            th Subtotal
                            th Acciones
                        tbody
                          tr(v-for="(item, index) in editedItem.items" :key="index")
                            td
                              v-select(v-model='item.product', :items='products', item-text='name', item-value='_id', dense='' :disabled='!editedItem.supplier')
                            td
                              v-select( v-model='item.unit' :items='item.availableUnits || []' item-text='name' item-value='_id' dense='' :disabled='!item.product')
                            td
                              v-text-field(v-model.number='item.quantity', type='number', dense='')
                            td
                              v-text-field(v-model.number='item.price', type='number', prefix='$', dense='')
                            td
                              strong ${{ item.quantity * item.price }}
                            td
                              v-btn(icon='', small='', color='error', @click='removeItem(index)')
                                v-icon mdi-delete
                    v-btn.mt-2(text='', color='primary', @click='addItem')
                      v-icon(left='') mdi-plus
                      |  Agregar Item
                  v-col(cols='12')
                    v-divider.my-2
                    .d-flex.justify-end
                      .text-h6
                        | Total: ${{ calculateTotal }}
            v-card-actions
              v-spacer
              v-btn(text='', @click='closeDialog')  Cancelar
              v-btn(color='primary', :disabled='!valid', @click='save')  Guardar
        // Document View Dialog
        v-dialog(v-model="viewDialog" max-width="800")
          v-card(v-if="selectedDocument")
            v-card-title
              | {{ getDocumentType(selectedDocument.type) }} # {{ selectedDocument.number }}
              v-spacer
              v-btn(icon @click="viewDialog = false")
                v-icon mdi-close

            v-card-text
              v-list(dense)
                // Información básica
                v-list-item
                  v-list-item-content
                    v-list-item-title Fecha
                    v-list-item-subtitle {{ formatDate(selectedDocument.date) }}
                v-list-item
                  v-list-item-content
                    v-list-item-title Proveedor
                    v-list-item-subtitle {{ selectedDocument.supplier.businessName }}
                // Items del documento
                v-divider.my-2
                v-list-item
                  v-list-item-content
                    v-list-item-title.font-weight-bold Artículos
                v-list-item(v-for="item in selectedDocument.items" :key="item._id")
                  v-list-item-content
                    v-list-item-title {{ item.product.name }}
                    v-list-item-subtitle
                      | Cantidad: {{ item.quantity }} {{ item.unit.name }}
                      br
                      | Precio unitario: ${{ item.price }}
                  v-list-item-action
                    | ${{ item.quantity * item.price }}
                // Totales
                v-divider.my-2
                v-list-item
                  v-list-item-content
                    v-list-item-title.font-weight-bold Total
                  v-list-item-action.font-weight-bold
                    | ${{ selectedDocument.total }}
                // Impuestos si existen
                template(v-if="selectedDocument.taxes && selectedDocument.taxes.length")
                  v-divider.my-2
                  v-list-item
                    v-list-item-content
                      v-list-item-title.font-weight-bold Impuestos
                  v-list-item(v-for="tax in selectedDocument.taxes" :key="tax._id")
                    v-list-item-content
                      v-list-item-title {{ tax.type.name }}
                    v-list-item-action
                      | ${{ tax.amount }}
                // Notas si existen
                template(v-if="selectedDocument.notes")
                  v-divider.my-2
                  v-list-item
                    v-list-item-content
                      v-list-item-title.font-weight-bold Notas
                      v-list-item-subtitle {{ selectedDocument.notes }}
            v-card-actions
              v-spacer
              v-btn(text @click="viewDialog = false") Cerrar
              v-btn(color="primary" @click="printDocument")
                v-icon(left) mdi-printer
                | Imprimir

</template>
<script>
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

export default {
  name: 'DocumentsView',

  data: () => ({
    loading: false,
    dialog: false,
    viewDialog: false,
    dateMenu: false,
    valid: false,
    units: [],
    search: '',
    headers: [
      { text: 'Tipo', value: 'type' },
      { text: 'Número', value: 'number' },
      { text: 'Fecha', value: 'date' },
      { text: 'Proveedor', value: 'supplier.businessName' },
      { text: 'Total', value: 'total' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    documentTypes: [
      { text: 'Factura A', value: 'INVOICE_A' },
      { text: 'Factura B', value: 'INVOICE_B' },
      { text: 'Factura C', value: 'INVOICE_C' },
      { text: 'Nota de Crédito', value: 'CREDIT_NOTE' },
      { text: 'Nota de Débito', value: 'DEBIT_NOTE' },
      { text: 'Remito', value: 'DELIVERY_NOTE' }
    ],
    selectedDocument: null,
    editedItem: {
      type: '',
      number: '',
      date: new Date().toISOString().substr(0, 10),
      supplier: null,
      items: [],
      total: null
    },
    item: {},
    defaultItem: {
      type: '',
      number: '',
      date: new Date().toISOString().substr(0, 10),
      supplier: null,
      items: [],
      total: null,
      availableUnits: []
    }
  }),
  // Add watch for supplier change:
  watch: {
    'editedItem.items': {
      deep: true,
      handler(items) {
        items.forEach(async item => {
          if (item.product) {
            // Find the selected product
            const product = this.products.find(p => p._id === item.product)
            if (product) {
              // Set available units for this item
              item.availableUnits = product.units || []
            }
          }
        })
      }
    },
    'editedItem.supplier': {
      async handler(supplierId) {
        if (supplierId) {
          try {
            if (supplierId._id) {
              const { data } = await this.$http.get(`/items/supplier/${supplierId._id}`)
              this.$store.commit('items/SET_ITEMS', data)
            } else {
              const { data } = await this.$http.get(`/items/supplier/${supplierId}`)
              this.$store.commit('items/SET_ITEMS', data)
            }
          } catch (error) {
            this.$toast.error('Error al cargar artículos del proveedor')
          }
        }
      }
    }
  },
  computed: {
    // Update items computed property:
    products() {
      if (this.editedItem?.supplier) {
        return this.$store.state.items.list
      } else {
        return []
      }
    },
    documents() {
      return this.$store.state.documents.list
    },
    suppliers() {
      return this.$store.state.suppliers.list
    },
    calculateTotal() {
      return this.editedItem.items.reduce((total, item) => {
        return total + (item.quantity * item.price)
      }, 0)
    }
  },

  methods: {
    addItem() {
      this.editedItem.items.push({
        product: null,
        unit: null,
        quantity: 1,
        price: 0,
        availableUnits: []
      })
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy', { locale: es })
    },
    getDocumentType(type) {
      const found = this.documentTypes.find(t => t.value === type)
      return found ? found.text : type
    },

    async openDialog(item = null) {
      this.editedItem = item ? { ...item } : { ...this.defaultItem }
      // If editing an existing document, populate available units for each item
      if (item) {
        this.editedItem.items = await Promise.all(item.items.map(async docItem => {
          // Find the product details
          const product = this.products.find(p => p._id === docItem.product._id)
          return {
            ...docItem,
            // Set available units from the product
            availableUnits: product?.units || []
          }
        }))
      }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem }
        this.$refs.form.reset()
      })
    },
    removeItem(index) {
      this.editedItem.items.splice(index, 1)
    },

    async save() {
      if (!this.$refs.form.validate()) return

      try {
        if (this.editedItem._id) {
          await this.$store.dispatch('documents/update', this.editedItem)
          this.$toast.success('Documento actualizado')
        } else {
          this.editedItem.total = this.calculateTotal
          await this.$store.dispatch('documents/create', this.editedItem)
          this.$toast.success('Documento creado')
        }
        this.closeDialog()
      } catch (error) {
        this.$toast.error('Error al guardar el documento')
      }
    },

    viewDocument(document) {
      this.selectedDocument = document
      this.viewDialog = true
    },

    printDocument() {
      // Implement print functionality
    }
  },

  async created() {
    this.loading = true
    try {
      await Promise.all([
        this.$store.dispatch('documents/fetch'),
        this.$store.dispatch('suppliers/fetch'),
        this.$store.dispatch('items/fetch')
      ])
    } catch (error) {
      this.$toast.error('Error al cargar los datos')
    } finally {
      this.loading = false
    }
  }
}
</script>
